import { client } from '@/lib/api/client'
import { venueCourtOperatingHoursPath } from '@/lib/api/config'
import { toApiError } from '@/lib/api/errors'

import type { CourtOperatingHourSaveInput, CourtOperatingHourView } from './operatingHourTypes'

/**
 * `GET .../operating-hours` (#600 §1).
 * 🚨 게이팅 대상이 아니다 — 이용권이 만료돼도 항상 200(무엇이 잠겼는지는 `editable` 로 안다).
 */
export async function fetchCourtOperatingHours(
  venueId: string,
  courtId: number
): Promise<CourtOperatingHourView> {
  try {
    const { data } = await client.get<CourtOperatingHourView>(
      venueCourtOperatingHoursPath(venueId, courtId)
    )
    return data
  } catch (error) {
    throw toApiError(error)
  }
}

/**
 * `PUT .../operating-hours` (#600 §2).
 * 🚨 전체 치환 — `input.days` 에 없는 요일은 미운영으로 저장된다. 응답은 `GET` 과 동일한 View.
 */
export async function saveCourtOperatingHours(
  venueId: string,
  courtId: number,
  input: CourtOperatingHourSaveInput
): Promise<CourtOperatingHourView> {
  try {
    const { data } = await client.put<CourtOperatingHourView>(
      venueCourtOperatingHoursPath(venueId, courtId),
      input
    )
    return data
  } catch (error) {
    throw toApiError(error)
  }
}
